export default __webpack_public_path__ + "static/media/cell.9addf0c7.png";